import { defineComponent as _defineComponent } from 'vue'

export enum SurfacePostPollChoiceInteractionsDisabled {
  All,
  Select,
  None,
}

import { type PollTailwindClasses } from '@@/bits/post_color'
import type { Id } from '@@/types'
import OzDivider, { OzDividerColorScheme } from 'library/v4/components/OzDivider.vue'
import OzIcon from 'library/v4/components/OzIcon.vue'
import { computed, toRefs } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SurfacePostPollChoice',
  props: {
    selected: { type: Boolean },
    choiceText: null,
    choiceId: null,
    index: null,
    numChoices: null,
    darkMode: { type: [Boolean, String], default: 'auto' },
    displayMode: { default: 'default' },
    isStream: { type: Boolean, default: false },
    pollColors: null,
    interactionsDisabled: { default: SurfacePostPollChoiceInteractionsDisabled.None },
    pollScaleMultiplier: { default: 1 }
  },
  emits: ["select"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'select', choiceId: Id): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { selected: boolean, choiceText: string, choiceId: Id, index: number, numChoices: number, darkMode: boolean | 'auto', displayMode: 'expanded' | 'default' | 'slideshow', isStream: boolean, pollColors: PollTailwindClasses, interactionsDisabled: SurfacePostPollChoiceInteractionsDisabled, pollScaleMultiplier: number }





const {
  selected,
  choiceText,
  choiceId,
  darkMode,
  displayMode,
  isStream,
  numChoices,
  pollColors,
  index,
  interactionsDisabled,
  pollScaleMultiplier,
} = toRefs(props)

const isDisplayModeExpanded = computed(() => displayMode.value === 'expanded')
const isDisplayModeSlideshow = computed(() => displayMode.value === 'slideshow')
const isDisplayModeExpandedOrSlideshow = computed(() => isDisplayModeExpanded.value || isDisplayModeSlideshow.value)

const onSelect = () => {
  if (
    interactionsDisabled.value === SurfacePostPollChoiceInteractionsDisabled.All ||
    interactionsDisabled.value === SurfacePostPollChoiceInteractionsDisabled.Select
  )
    return
  emit('select', choiceId.value)
}

return { __sfc: true,SurfacePostPollChoiceInteractionsDisabled, emit, props, selected, choiceText, choiceId, darkMode, displayMode, isStream, numChoices, pollColors, index, interactionsDisabled, pollScaleMultiplier, isDisplayModeExpanded, isDisplayModeSlideshow, isDisplayModeExpandedOrSlideshow, onSelect, OzDivider, OzDividerColorScheme, OzIcon }
}

})